import {Injectable} from '@angular/core';
import {Observable, zip} from "rxjs";
import {Event} from "../../model/Event";
import {FaqCategory} from "../../model/FaqCategory";
import {FaqCategoryService} from "../../services/faq-category.service";
import {map} from "rxjs/operators";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";

@Injectable({
  providedIn: 'root'
})
export class EventFormGeneratorService implements FormGeneratorService {

  constructor(private faqCategoryService: FaqCategoryService) {
  }

  getQuestions(event: Event): Observable<FieldDefinition<any>[]> {
    return zip(
      this.faqCategoryService.getAllCategories()
    ).pipe(
      map(pairs => {
        const questions = [
          new FieldDefinition<string>({
            key: "type",
            label: 'Type de l\'événement',
            type: 'text',
            value: event.type,
            required: true,
            order: 1
          }),
          new FieldDefinition<string>({
            key: "datetime",
            label: 'Date de l\'événement',
            type: 'date',
            placeholder: 'jj/mm/aaaa',
            value: event.datetime ? new Date(event.datetime).toISOString().split('T')[0] : '',
            fullsize: false,
            required: true,
            order: 2
          }),
          new FieldDefinition<string>({
            key: "title",
            label: 'Titre de l\'événement',
            type: 'text',
            value: event.title,
            required: true,
            order: 3
          }),
          new FieldDefinition<string>({
            key: 'description',
            label: 'Description de l\'événement',
            type: 'text',
            value: event.description,
            required: true,
            order: 4
          }),
          new FieldDefinition<string>({
            key: 'linktitle',
            label: 'Texte du bouton d\'action',
            type: 'text',
            value: event.linktitle,
            required: true,
            order: 5
          }),
          new FieldDefinition<string>({
            key: 'link',
            label: 'Cible du bouton d\'action',
            type: 'text',
            warn: 'Une adresse en https:// est requise',
            value: event.link,
            required: true,
            order: 6
          }),
          new FieldDefinition<string>({
            key: "beginDate",
            label: 'Date de début d\'affichage pour les clients',
            type: 'date',
            placeholder: 'jj/mm/aaaa',
            value: event.beginDate ? new Date(event.beginDate).toISOString().split('T')[0] : '',
            fullsize: false,
            required: true,
            order: 7
          }),
          new FieldDefinition<string>({
            key: "endDate",
            label: 'Date de fin d\'affichage pour les clients',
            type: 'date',
            placeholder: 'jj/mm/aaaa',
            value: event.endDate ? new Date(event.endDate).toISOString().split('T')[0] : '',
            fullsize: false,
            required: true,
            order: 8,
          }),
          new FieldDefinition<FaqCategory[]>({
            key: 'categories',
            label: 'Logiciel(s) concerné(s)',
            type: 'select2',
            placeholder: 'Sélectionner le(s) logiciel(s) concerné(s)',
            multiple: true,
            required: true,
            value: event.categories,
            options: pairs[0],
            order: 9
          }),
        ];

        return questions.sort((a, b) => a.order - b.order);
      }));
  }
}
